import { Check } from "lucide-react";

export const ReasonStep = ({ reasons, value, onSelect }) => (
  <div data-testid="reason-step">
    <p className="text-sm font-semibold text-ink mb-3">Step 1 · What brings you in?</p>
    <div className="space-y-2.5">
      {reasons.map((r) => {
        const active = r.id === value;
        return (
          <button key={r.id} type="button" onClick={() => onSelect(r.id)} data-testid={`reason-option-${r.id}`}
            className={`w-full flex items-center gap-3 text-left rounded-2xl border px-4 py-3.5 transition-[background-color,border-color,transform] duration-200 hover:-translate-y-0.5 ${active ? "border-teal bg-mint" : "border-slate-200 bg-white hover:border-teal/40 hover:bg-mint/40"}`}>
            <span className={`h-5 w-5 rounded-full border-2 grid place-items-center shrink-0 ${active ? "border-teal bg-teal" : "border-slate-300"}`}>
              {active && <Check className="h-3 w-3 text-white" />}
            </span>
            <span className="flex-1 min-w-0">
              <span className="block text-sm sm:text-[15px] font-medium text-ink">{r.title}</span>
              {r.description && <span className="block text-xs text-ink-muted mt-0.5">{r.description}</span>}
            </span>
          </button>
        );
      })}
    </div>
  </div>
);
